import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';

const Menu = () => {
  const [productos, setProductos] = useState([]);
  const [categoriaSeleccionada, setCategoriaSeleccionada] = useState('Todas');
  const [loading, setLoading] = useState(true);
  const [mostrarCategorias, setMostrarCategorias] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Cargar productos desde Firebase
  useEffect(() => {
    const cargarProductos = async () => {
      try {
        setLoading(true);
        const productosSnapshot = await getDocs(collection(db, "productos"));
        const productosData = productosSnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setProductos(productosData);
      } catch (error) {
        console.error("Error al cargar productos:", error);
      } finally {
        setLoading(false);
      }
    };

    cargarProductos();
  }, []);

  // Detectar cambios de tamaño de ventana para móvil
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setMostrarCategorias(false); // Resetear al cambiar a desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Obtener categorías únicas
  const categorias = ['Todas', ...new Set(productos.map(p => p.categoria).filter(Boolean))];

  // Filtrar productos por categoría
  const productosFiltrados = categoriaSeleccionada === 'Todas' 
    ? productos 
    : productos.filter(p => p.categoria === categoriaSeleccionada);

  // Función para formatear números
  const formatearNumero = (numero) => {
    return new Intl.NumberFormat('es-CO').format(numero);
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: 'white',
        color: '#251404'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '50px',
            height: '50px',
            border: '4px solid #b5855f',
            borderTop: '4px solid #251404',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 20px'
          }}></div>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>Cargando menú...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: `
        radial-gradient(circle at 20% 20%, rgba(181, 133, 95, 0.15) 0%, transparent 40%),
        radial-gradient(circle at 80% 80%, rgba(37, 20, 4, 0.15) 0%, transparent 40%),
        radial-gradient(circle at 40% 60%, rgba(181, 133, 95, 0.08) 0%, transparent 35%),
        radial-gradient(circle at 60% 40%, rgba(37, 20, 4, 0.08) 0%, transparent 35%),
        linear-gradient(45deg, #ffffff 25%, transparent 25%),
        linear-gradient(-45deg, #ffffff 25%, transparent 25%),
        linear-gradient(45deg, transparent 75%, #f8f6f0 75%),
        linear-gradient(-45deg, transparent 75%, #f5f3ed 75%),
        linear-gradient(135deg, #ffffff 0%, #f8f6f0 25%, #ffffff 50%, #f5f3ed 75%, #ffffff 100%)
      `,
      backgroundSize: '50px 50px, 50px 50px, 80px 80px, 80px 80px, 20px 20px, 20px 20px, 20px 20px, 20px 20px, 100% 100%',
      backgroundPosition: '0 0, 25px 25px, 0 0, 40px 40px, 0 0, 10px 10px, 10px 10px, 0 10px, 0 0',
      fontFamily: 'Arial, sans-serif',
      position: 'relative',
      overflow: 'hidden'
    }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          
          @keyframes shimmer {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
          
          @keyframes slideInLeft {
            from { transform: translateX(-50px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          
          @keyframes slideInRight {
            from { transform: translateX(50px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }
          
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
          
          @keyframes coffee-steam {
            0% { transform: translateY(0) scale(1); opacity: 0.7; }
            50% { transform: translateY(-20px) scale(1.1); opacity: 0.3; }
            100% { transform: translateY(-40px) scale(0.8); opacity: 0; }
          }
          
          .menu-container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
            position: relative;
            z-index: 2;
          }
          
          .category-button {
            transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            position: relative;
            overflow: hidden;
          }
          
          .category-button::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent);
            transition: left 0.5s;
          }
          
          .category-button:hover::before {
            left: 100%;
          }
          
          .category-button:hover {
            transform: translateY(-3px) scale(1.05);
            box-shadow: 0 8px 25px rgba(37, 20, 4, 0.3);
          }
          
          .product-item {
            transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
            position: relative;
            overflow: hidden;
          }
          
          .product-item::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
            transition: left 0.6s;
          }
          
          .product-item:hover::before {
            left: 100%;
          }
          
          .product-item:hover {
            transform: translateY(-5px) scale(1.02);
            background-color: rgba(255, 255, 255, 0.3) !important;
            box-shadow: 0 10px 30px rgba(37, 20, 4, 0.2);
          }
          
          .product-item-white:hover {
            background-color: rgba(181, 133, 95, 0.1) !important;
            box-shadow: 0 10px 30px rgba(181, 133, 95, 0.2);
          }
          
          .left-column {
            background: linear-gradient(135deg, #251404 0%, #3d2409 50%, #251404 100%);
            position: relative;
            overflow: hidden;
          }
          
          .left-column::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: 
              radial-gradient(circle at 20% 80%, rgba(181, 133, 95, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 80% 20%, rgba(181, 133, 95, 0.2) 0%, transparent 50%),
              repeating-linear-gradient(
                45deg,
                transparent,
                transparent 2px,
                rgba(255, 255, 255, 0.03) 2px,
                rgba(255, 255, 255, 0.03) 4px
              );
            pointer-events: none;
          }
          
          .left-column-animation {
            animation: slideInLeft 0.8s ease-out;
          }
          
          .right-column-animation {
            animation: slideInRight 0.8s ease-out;
          }
          
          .floating-element {
            /* Animación flotante removida */
          }
          
          .floating-element:nth-child(odd) {
            /* Delay removido */
          }
          
          .product-item {
            transition: all 0.3s ease;
          }

          .product-item:hover {
            transform: translateY(-3px);
            box-shadow: 0 15px 40px rgba(181, 133, 95, 0.25) !important;
          }

          /* Animación para el botón de WhatsApp */
          @keyframes whatsapp-pulse {
            0% {
              box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
            }
            50% {
              box-shadow: 0 6px 30px rgba(37, 211, 102, 0.7);
            }
            100% {
              box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
            }
          }

          .whatsapp-btn {
            animation: whatsapp-pulse 2s infinite;
          }

          /* Responsive para el botón de WhatsApp */
          @media (max-width: 768px) {
            .whatsapp-btn {
              width: 55px;
              height: 55px;
              bottom: 15px;
              right: 15px;
            }
          }
          
          .steam {
            position: absolute;
            width: 4px;
            height: 4px;
            background: rgba(255, 255, 255, 0.8);
            border-radius: 50%;
            animation: coffee-steam 3s infinite;
          }
          
          .steam:nth-child(1) { animation-delay: 0s; left: 30%; }
          .steam:nth-child(2) { animation-delay: 0.5s; left: 50%; }
          .steam:nth-child(3) { animation-delay: 1s; left: 70%; }
          
          .logo-container {
            position: relative;
            display: inline-block;
          }
          
          .logo-container::after {
            content: '';
            position: absolute;
            top: -20px;
            left: 50%;
            transform: translateX(-50%);
            width: 120%;
            height: 10px;
            background: linear-gradient(90deg, transparent, rgba(181, 133, 95, 0.3), transparent);
            border-radius: 50%;
            animation: shimmer 3s infinite;
          }
          
          @media (max-width: 768px) {
            .menu-container {
              padding: 15px;
            }
            .products-grid {
              grid-template-columns: 1fr !important;
            }
            .left-column-animation,
            .right-column-animation {
              animation: none;
            }
            
            /* Estilos para categorías móvil */
            .categorias-container {
              position: relative;
            }
            
            .categorias-mobile-hidden {
              max-height: 85px;
              overflow: hidden;
              transition: max-height 0.4s ease-in-out;
            }
            
            .categorias-mobile-visible {
              max-height: 600px;
              transition: max-height 0.4s ease-in-out;
            }
            
            .toggle-categorias-btn {
              position: absolute;
              top: 15px;
              right: 15px;
              width: 40px;
              height: 40px;
              border-radius: 12px;
              background: linear-gradient(135deg, #251404 0%, #3d2409 50%, #251404 100%);
              color: white;
              border: 1px solid rgba(255, 255, 255, 0.3);
              cursor: pointer;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 16px;
              box-shadow: 0 3px 12px rgba(37, 20, 4, 0.4);
              transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
              z-index: 10;
            }
            
            .toggle-categorias-btn:hover {
              transform: scale(1.05);
              box-shadow: 0 4px 16px rgba(37, 20, 4, 0.5);
              background: linear-gradient(135deg, #3d2409 0%, #251404 50%, #3d2409 100%);
            }
            
            .toggle-categorias-btn:active {
              transform: scale(0.9);
              box-shadow: 0 2px 8px rgba(37, 20, 4, 0.6);
            }
            
            .categorias-grid-mobile {
              display: grid;
              grid-template-columns: repeat(2, 1fr);
              gap: 12px;
              padding: 15px 10px 10px 10px;
            }
            
            .category-button-mobile {
              padding: 12px 16px !important;
              font-size: 14px !important;
              min-width: unset !important;
              text-align: center;
            }
          }
          
          /* Partículas de fondo removidas */
          .background-particle {
            position: absolute;
            border-radius: 50%;
            pointer-events: none;
            opacity: 0.1;
          }
          
          .particle-1 {
            width: 8px;
            height: 8px;
            background: #b5855f;
            top: 10%;
            left: 5%;
            animation: float 8s ease-in-out infinite;
          }
          
          .particle-2 {
            width: 6px;
            height: 6px;
            background: #251404;
            top: 20%;
            right: 10%;
            animation: float 6s ease-in-out infinite reverse;
          }
          
          .particle-3 {
            width: 10px;
            height: 10px;
            background: #b5855f;
            bottom: 30%;
            left: 8%;
            animation: float 10s ease-in-out infinite;
          }
          
          .particle-4 {
            width: 4px;
            height: 4px;
            background: #251404;
            bottom: 10%;
            right: 15%;
            animation: float 7s ease-in-out infinite reverse;
          }
        `}
      </style>

      {/* Partículas de fondo mejoradas */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        background: `
          radial-gradient(2px 2px at 20px 30px, rgba(181, 133, 95, 0.3), transparent),
          radial-gradient(2px 2px at 40px 70px, rgba(37, 20, 4, 0.3), transparent),
          radial-gradient(1px 1px at 90px 40px, rgba(181, 133, 95, 0.4), transparent),
          radial-gradient(1px 1px at 130px 80px, rgba(37, 20, 4, 0.4), transparent),
          radial-gradient(2px 2px at 160px 30px, rgba(181, 133, 95, 0.3), transparent)
        `,
        backgroundRepeat: 'repeat',
        backgroundSize: '200px 100px',
        opacity: 0.6
      }}></div>

      {/* Textura adicional */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        pointerEvents: 'none',
        background: `
          repeating-linear-gradient(
            45deg,
            transparent,
            transparent 2px,
            rgba(181, 133, 95, 0.02) 2px,
            rgba(181, 133, 95, 0.02) 4px
          ),
          repeating-linear-gradient(
            -45deg,
            transparent,
            transparent 2px,
            rgba(37, 20, 4, 0.02) 2px,
            rgba(37, 20, 4, 0.02) 4px
          )
        `
      }}></div>

      <div className="menu-container">
        {/* Header con Logo */}
        <header style={{
          textAlign: 'center',
          marginBottom: '40px',
          padding: '40px 20px',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderRadius: '20px',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(181, 133, 95, 0.2)',
          boxShadow: '0 15px 35px rgba(37, 20, 4, 0.1)',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'linear-gradient(45deg, transparent 30%, rgba(181, 133, 95, 0.05) 50%, transparent 70%)',
            animation: 'shimmer 4s infinite'
          }}></div>
          
          <div className="logo-container floating-element">
            <img 
              src="/logo.png" 
              alt="Kardhamo Logo"
              style={{
                height: '100px',
                width: 'auto',
                marginBottom: '20px',
                filter: 'drop-shadow(0 5px 15px rgba(37, 20, 4, 0.3))',
                position: 'relative',
                zIndex: 2
              }}
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div style={{
              display: 'none',
              fontSize: '64px',
              marginBottom: '20px',
              position: 'relative'
            }}>
              🍽️
              <div className="steam"></div>
              <div className="steam"></div>
              <div className="steam"></div>
            </div>
          </div>
          
          <h1 style={{
            margin: '0 0 15px 0',
            fontSize: isMobile ? '32px' : '42px',
            fontWeight: 'bold',
            color: '#251404',
            background: 'linear-gradient(135deg, #251404 0%, #b5855f 50%, #251404 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            textShadow: '0 2px 4px rgba(37, 20, 4, 0.1)',
            position: 'relative',
            zIndex: 2
          }}>
            Nuestro Menú 
          </h1>
          <p style={{
            margin: '0',
            fontSize: isMobile ? '18px' : '20px',
            color: '#b5855f',
            fontWeight: '500',
            position: 'relative',
            zIndex: 2
          }}>
            ✨ Sabores únicos que despiertan tus sentidos ✨
          </p>
        </header>

        {/* Filtros de categoría */}
        <div 
          className="categorias-container"
          style={{
            marginBottom: '50px',
            padding: isMobile ? '15px' : '20px',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderRadius: '20px',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(181, 133, 95, 0.2)',
            position: 'relative'
          }}
        >
          {/* Botón para mostrar/ocultar categorías en móvil */}
          {isMobile && (
            <button
              className="toggle-categorias-btn"
              onClick={() => setMostrarCategorias(!mostrarCategorias)}
              title={mostrarCategorias ? "Ocultar categorías" : "Ver todas las categorías"}
              style={{
                transform: mostrarCategorias ? 'rotate(180deg)' : 'rotate(0deg)'
              }}
            >
              {mostrarCategorias ? '▲' : '☰'}
            </button>
          )}
          
          <div 
            className={isMobile 
              ? (mostrarCategorias ? 'categorias-mobile-visible' : 'categorias-mobile-hidden')
              : ''
            }
            style={{
              display: isMobile 
                ? (mostrarCategorias ? 'block' : 'flex')
                : 'flex',
              flexWrap: 'wrap',
              gap: '15px',
              justifyContent: 'center'
            }}
          >
            {isMobile && mostrarCategorias ? (
              <div className="categorias-grid-mobile">
                {categorias.map(categoria => (
                  <button
                    key={categoria}
                    onClick={() => {
                      setCategoriaSeleccionada(categoria);
                      setMostrarCategorias(false); // Ocultar después de seleccionar
                    }}
                    className="category-button category-button-mobile floating-element"
                    style={{
                      padding: '12px 16px',
                      background: categoriaSeleccionada === categoria 
                        ? 'linear-gradient(135deg, #251404 0%, #3d2409 50%, #251404 100%)'
                        : 'linear-gradient(135deg, #b5855f 0%, #d4a574 50%, #b5855f 100%)',
                      color: 'white',
                      border: 'none',
                      borderRadius: '25px',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      cursor: 'pointer',
                      boxShadow: categoriaSeleccionada === categoria 
                        ? '0 6px 20px rgba(37, 20, 4, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
                        : '0 4px 15px rgba(181, 133, 95, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
                      textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
                      position: 'relative',
                      overflow: 'hidden',
                      textAlign: 'center'
                    }}
                  >
                    {categoria}
                  </button>
                ))}
              </div>
            ) : isMobile ? (
              // Mostrar solo la categoría seleccionada en móvil cuando esté colapsado
              <div style={{ 
                display: 'flex', 
                flexDirection: 'column',
                alignItems: 'center', 
                justifyContent: 'center',
                gap: '8px',
                padding: '5px 50px 5px 10px'
              }}>
                <button
                  className="category-button floating-element"
                  onClick={() => setMostrarCategorias(true)}
                  style={{
                    padding: '12px 20px',
                    background: 'linear-gradient(135deg, #251404 0%, #3d2409 50%, #251404 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '25px',
                    fontSize: '15px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    width: '100%',
                    maxWidth: '200px',
                    boxShadow: '0 6px 20px rgba(37, 20, 4, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
                    position: 'relative',
                    overflow: 'hidden',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                >
                  <span>🏷️</span>
                  <span>{categoriaSeleccionada}</span>
                </button>
                <span style={{
                  fontSize: '11px',
                  color: '#b5855f',
                  fontWeight: '600',
                  opacity: 0.7,
                  textAlign: 'center'
                }}>
                  Toca ☰ para ver todas las categorías
                </span>
              </div>
            ) : (
              // Vista desktop normal
              categorias.map(categoria => (
                <button
                  key={categoria}
                  onClick={() => setCategoriaSeleccionada(categoria)}
                  className="category-button floating-element"
                  style={{
                    padding: '15px 30px',
                    background: categoriaSeleccionada === categoria 
                      ? 'linear-gradient(135deg, #251404 0%, #3d2409 50%, #251404 100%)'
                      : 'linear-gradient(135deg, #b5855f 0%, #d4a574 50%, #b5855f 100%)',
                    color: 'white',
                    border: 'none',
                    borderRadius: '30px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    minWidth: '140px',
                    boxShadow: categoriaSeleccionada === categoria 
                      ? '0 8px 25px rgba(37, 20, 4, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.2)'
                      : '0 6px 20px rgba(181, 133, 95, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)',
                    position: 'relative',
                    overflow: 'hidden'
                  }}
                >
                  {categoria}
                </button>
              ))
            )}
          </div>
        </div>

        {/* Grid de productos en dos columnas */}
        {productosFiltrados.length === 0 ? (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            backgroundColor: '#f8f8f8',
            borderRadius: '15px',
            color: '#251404'
          }}>
            <h3 style={{ margin: '0 0 10px 0', fontSize: '24px' }}>
              No hay productos disponibles
            </h3>
            <p style={{ margin: '0', fontSize: '16px', opacity: 0.7 }}>
              {categoriaSeleccionada === 'Todas' 
                ? 'Aún no se han agregado productos al menú'
                : `No hay productos en la categoría "${categoriaSeleccionada}"`
              }
            </p>
          </div>
        ) : (
          <div 
            className="products-grid"
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
              gap: '30px'
            }}
          >
            {/* Columna izquierda */}
            <div className="left-column left-column-animation" style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '20px',
              padding: '25px',
              borderRadius: '20px',
              position: 'relative',
              boxShadow: '0 15px 35px rgba(37, 20, 4, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)'
            }}>
              {productosFiltrados.filter((_, index) => index % 2 === 0).map((producto, index) => (
                <div
                  key={producto.id}
                  className="product-item floating-element"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px',
                    borderRadius: '15px',
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    border: '1px solid rgba(255, 255, 255, 0.25)',
                    backdropFilter: 'blur(10px)',
                    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.2)',
                    animationDelay: `${index * 0.1}s`,
                    position: 'relative',
                    zIndex: 1
                  }}
                >
                  {/* Imagen del producto */}
                  <div style={{
                    width: '90px',
                    height: '90px',
                    marginRight: '20px',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    flexShrink: 0,
                    border: '3px solid rgba(255, 255, 255, 0.3)',
                    boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)'
                  }}>
                    {producto.imagenURL ? (
                      <img
                        src={producto.imagenURL}
                        alt={producto.nombre}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.3s ease'
                        }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                      />
                    ) : null}
                    <div style={{
                      display: producto.imagenURL ? 'none' : 'flex',
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(255, 255, 255, 0.2)',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '28px',
                      color: 'white'
                    }}>
                      🍽️
                    </div>
                  </div>

                  {/* Información del producto */}
                  <div style={{ flex: 1 }}>
                    {/* Categoría */}
                    {producto.categoria && (
                      <span style={{
                        display: 'inline-block',
                        padding: '4px 12px',
                        background: 'linear-gradient(135deg, #b5855f 0%, #d4a574 100%)',
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        borderRadius: '15px',
                        marginBottom: '10px',
                        textTransform: 'uppercase',
                        boxShadow: '0 3px 10px rgba(181, 133, 95, 0.4)',
                        textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
                      }}>
                        {producto.categoria}
                      </span>
                    )}

                    {/* Nombre del producto */}
                    <h3 style={{
                      margin: '0 0 10px 0',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: 'white',
                      lineHeight: '1.3',
                      textShadow: '0 2px 4px rgba(0, 0, 0, 0.5)'
                    }}>
                      {producto.nombre}
                    </h3>

                    {/* Precio */}
                    <span style={{
                      fontSize: '22px',
                      fontWeight: 'bold',
                      color: '#d4a574',
                      textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
                      background: 'linear-gradient(135deg, #d4a574 0%, #f0c674 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text'
                    }}>
                      ${formatearNumero(producto.precio)}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            {/* Columna derecha */}
            <div className="right-column-animation" style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              gap: '20px',
              padding: '25px',
              backgroundColor: 'rgba(255, 255, 255, 0.9)',
              borderRadius: '20px',
              backdropFilter: 'blur(10px)',
              border: '1px solid rgba(181, 133, 95, 0.2)',
              boxShadow: '0 15px 35px rgba(181, 133, 95, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.8)',
              position: 'relative',
              overflow: 'hidden'
            }}>
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'linear-gradient(135deg, transparent 30%, rgba(181, 133, 95, 0.03) 50%, transparent 70%)',
                animation: 'shimmer 6s infinite'
              }}></div>
              
              {productosFiltrados.filter((_, index) => index % 2 === 1).map((producto, index) => (
                <div
                  key={producto.id}
                  className="product-item product-item-white floating-element"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '20px',
                    borderRadius: '15px',
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    border: '1px solid rgba(181, 133, 95, 0.2)',
                    backdropFilter: 'blur(5px)',
                    boxShadow: '0 8px 25px rgba(181, 133, 95, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.8)',
                    animationDelay: `${index * 0.1 + 0.05}s`,
                    position: 'relative',
                    zIndex: 1
                  }}
                >
                  {/* Imagen del producto */}
                  <div style={{
                    width: '90px',
                    height: '90px',
                    marginRight: '20px',
                    borderRadius: '15px',
                    overflow: 'hidden',
                    flexShrink: 0,
                    border: '3px solid rgba(181, 133, 95, 0.3)',
                    boxShadow: '0 5px 15px rgba(181, 133, 95, 0.2)'
                  }}>
                    {producto.imagenURL ? (
                      <img
                        src={producto.imagenURL}
                        alt={producto.nombre}
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'cover',
                          transition: 'transform 0.3s ease'
                        }}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          e.target.nextSibling.style.display = 'flex';
                        }}
                        onMouseEnter={(e) => e.target.style.transform = 'scale(1.1)'}
                        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                      />
                    ) : null}
                    <div style={{
                      display: producto.imagenURL ? 'none' : 'flex',
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(181, 133, 95, 0.1)',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '28px',
                      color: '#b5855f'
                    }}>
                      🍽️
                    </div>
                  </div>

                  {/* Información del producto */}
                  <div style={{ flex: 1 }}>
                    {/* Categoría */}
                    {producto.categoria && (
                      <span style={{
                        display: 'inline-block',
                        padding: '4px 12px',
                        background: 'linear-gradient(135deg, #251404 0%, #3d2409 100%)',
                        color: 'white',
                        fontSize: '11px',
                        fontWeight: 'bold',
                        borderRadius: '15px',
                        marginBottom: '10px',
                        textTransform: 'uppercase',
                        boxShadow: '0 3px 10px rgba(37, 20, 4, 0.3)',
                        textShadow: '0 1px 2px rgba(0, 0, 0, 0.3)'
                      }}>
                        {producto.categoria}
                      </span>
                    )}

                    {/* Nombre del producto */}
                    <h3 style={{
                      margin: '0 0 10px 0',
                      fontSize: '20px',
                      fontWeight: 'bold',
                      color: '#251404',
                      lineHeight: '1.3',
                      textShadow: '0 1px 2px rgba(37, 20, 4, 0.1)'
                    }}>
                      {producto.nombre}
                    </h3>

                    {/* Precio */}
                    <span style={{
                      fontSize: '22px',
                      fontWeight: 'bold',
                      background: 'linear-gradient(135deg, #251404 0%, #b5855f 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      backgroundClip: 'text',
                      textShadow: '0 1px 2px rgba(37, 20, 4, 0.2)'
                    }}>
                      ${formatearNumero(producto.precio)}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Footer */}
        <footer style={{
          marginTop: '60px',
          textAlign: 'center',
          padding: '30px 20px',
          backgroundColor: '#251404',
          borderRadius: '15px',
          color: 'white'
        }}>
          <p style={{
            margin: '0',
            fontSize: '16px',
            opacity: 0.9
          }}>
            ¡Gracias por visitarnos! 🍽️ Para realizar un pedido, contacta con nuestro personal.
          </p>
        </footer>

        {/* Botón de WhatsApp flotante */}
        <div
          className="whatsapp-btn"
          onClick={() => {
            const mensaje = "¡Hola Kardhamo! Me interesa hacer un pedido.";
            const numeroWhatsapp = "573214599518"; // Cambia este número por el tuyo
            const url = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensaje)}`;
            window.open(url, '_blank');
          }}
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            width: '60px',
            height: '60px',
            backgroundColor: '#25D366',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            zIndex: 1000,
            border: '3px solid white'
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.1)';
            e.target.style.animationPlayState = 'paused';
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.animationPlayState = 'running';
          }}
        >
          <svg 
            width="30" 
            height="30" 
            viewBox="0 0 24 24" 
            fill="white"
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.525 3.488"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default Menu;